import React from "react";
import { emptyRequest, getRequest } from "../constants/requests";
import { useHttp } from "./useHttp";
import { useApp } from "./useApp";
import { addDoc, collection, } from "firebase/firestore";
import { firestore } from "../services/firebase";

const AuthContext = React.createContext();

const empty = emptyRequest();

export function AuthProvider(props) {
  const { token } = useApp();
  // const [sessionRequest, setSessionRequest] = React.useState(empty);
  // const [session, sessionLoading] = useHttp(sessionRequest);
  const [userAuth, setUserAuth] = React.useState(false);
  const [userData, setUserData] = React.useState([]);
  const [agendaRequest, setAgendaRequest] = React.useState(empty);
  const [agendaResponse, agendaResponseLoading] = useHttp(agendaRequest);
  const [ userDataLoading, setUserDataLoading ] = React.useState(true);
  const [ userToken, setUserToken ] = React.useState();

  // React.useEffect(() => {
  //   if (session && !sessionLoading) {
  //     if (session?.resultado?.[0]) {
  //       const { token } = session.resultado[0];
  //       setToken(token);
  //     }
  //   }
  // }, [session, sessionLoading, setToken]);

  React.useEffect(() => {
    if( userDataLoading  ) {
      if( userData.length > 0 ) {
        setUserToken(userData[0].idDoc)
      }
    }
  }, [ userDataLoading, userData ]);

  React.useEffect(() => {
    let currentuser = localStorage.getItem("usuario");
    if ( userAuth || currentuser) {
      setUserData( [ JSON.parse(localStorage.getItem("usuario")) ] );
      setUserAuth(true);
    }
  }, [userAuth,]);

  React.useEffect(() => {
    if (token) {
      const agendaReq = getRequest("usuario/perfil", {
        expand: "",
      });
      setAgendaRequest(() => agendaReq);
    } else {
      setAgendaRequest(() => empty);
    }
  }, [token]);

  const signIn = React.useCallback(async ( docData, idDoc ) => {

    setTimeout(() => {
      try {
        setUserAuth(true);
        localStorage.setItem("usuario", JSON.stringify({ sesion:true, idDoc, ...docData }));
        setUserData( [...userData, JSON.parse(localStorage.getItem("usuario")) ] );
        setUserDataLoading(false)
      } catch (e) {
        console.log(e);
      }
    }, 100)

  }, [ userData ]);

  const signUp = React.useCallback(async ( values ) => {
    
    let data = {
      ...values,
      rol: 'usuario',
      pin: Math.floor(1000 + Math.random() * 9000),
      estatus: 1,
      registro: new Date(),
    }
    try {
      const res = await addDoc(collection(firestore, "usuarios"), data );
      setUserAuth(true);
      localStorage.setItem("usuario", JSON.stringify({ sesion:true, idDoc: res.id, ...data }));
      setUserData( [...userData, JSON.parse(localStorage.getItem("usuario")) ] );
    } catch (e) {
      console.log(e);
    }
  }, [ userData ]);

 
  const signOut = React.useCallback(async () => {
    try {
      localStorage.clear();
      setUserData([]);
      setUserAuth(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const memData = React.useMemo(() => {
    return {
      // session,
      // sessionLoading,
      user:
        agendaResponse &&
        agendaResponse.resultado &&
        agendaResponse.resultado.length > 0
          ? {
              ...agendaResponse.resultado[0],
              permisoExtra: agendaResponse.detalle,
            }
          : null,
      userLoading: agendaResponseLoading,
      signIn,
      signOut,
      signUp,
      userAuth,
      userData,
      userDataLoading,
      userToken
    };
  }, [
    // session,
    // sessionLoading,
    agendaResponse,
    agendaResponseLoading,
    signIn,
    signOut,
    signUp,
    userAuth,
    userData,
    userDataLoading,
    userToken
  ]);

  return <AuthContext.Provider value={memData} {...props} />;
}

export function useAuth() {
  const context = React.useContext(AuthContext);
  if (!context) {
    // eslint-disable-next-line no-throw-literal
    throw "error: auth context not defined.";
  }
  return context;
}
